'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    getReadWidget: function getReadWidget() {
        return '<ma-date-column field="::field" value="::value"></ma-date-column>';
    },
    getLinkWidget: function getLinkWidget() {
        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
    },
    getFilterWidget: function getFilterWidget() {
        return '<ma-date-field field="::field" value="value"></ma-date-field>';
    },
    getWriteWidget: function getWriteWidget() {
        return '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
    }
};
module.exports = exports['default'];
//# sourceMappingURL=DateTimeFieldView.js.map


// WEBPACK FOOTER //
// ./~/ng-admin/lib/javascripts/ng-admin/Crud/fieldView/DateTimeFieldView.js